"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortcuts = exports.KEYBOARD_SHORTCUTS_MODAL_ID = void 0;
var shortcuts = [{
  id: 'navigation',
  title: 'Navigation',
  commands: [{
    title: 'Keyboard shortcuts',
    win: 'Alt 0',
    mac: 'Option 0'
  }, {
    title: 'Toggle full screen mode',
    win: 'Alt Enter',
    mac: 'Option Return'
  }, {
    title: 'Focus the toolbar',
    win: 'Alt F10',
    mac: 'Option F10'
  }, {
    title: 'Leave the toolbar',
    win: 'Escape',
    mac: 'Escape'
  }, {
    title: 'Focus link under text cursor',
    win: 'Shift Enter',
    mac: 'Shift Return'
  }]
}, {
  id: 'essentials',
  title: 'Essentials',
  commands: [{
    title: 'Copy',
    win: 'Control C',
    mac: 'Command C'
  }, {
    title: 'Cut',
    win: 'Control X',
    mac: 'Command X'
  }, {
    title: 'Paste',
    win: 'Control V',
    mac: 'Command V'
  }, {
    title: 'Paste without formatting',
    win: 'Control Shift V',
    mac: 'Command Shift V'
  }, {
    title: 'Undo',
    win: 'Control Z',
    mac: 'Command Z'
  }, {
    title: 'Redo',
    win: 'Control Shift Z',
    mac: 'Command Shift Z'
  }, {
    title: 'Add a line break',
    win: 'Shift Enter',
    mac: 'Shift Return'
  }, {
    title: 'Indent',
    win: 'Shift Alt I',
    mac: 'Shift Option I'
  }, {
    title: 'Outdent',
    win: 'Shift Alt O',
    mac: 'Shift Option O'
  }]
}, {
  id: 'text-formatting',
  title: 'Text Formatting',
  commands: [{
    title: 'Bold',
    win: 'Control B',
    mac: 'Command B'
  }, {
    title: 'Italic',
    win: 'Control I',
    mac: 'Command I'
  }, {
    title: 'Underline',
    win: 'Control U',
    mac: 'Command U'
  }, {
    title: 'Strikethrough',
    win: 'Control Shift X',
    mac: 'Command Shift X'
  }, {
    title: 'Code',
    win: 'Control E',
    mac: 'Command E'
  }, {
    title: 'Link',
    win: 'Control K',
    mac: 'Command K'
  }, {
    title: 'Image',
    win: 'Control J',
    mac: 'Command J'
  }]
}, {
  id: 'paragraph-formatting',
  title: 'Paragraph Formatting',
  commands: [{
    title: 'Apply normal text style',
    win: 'Control Alt 0',
    mac: 'Command Option 0'
  }, {
    title: 'Apply heading style 1',
    win: 'Control Alt 1',
    mac: 'Command Option 1'
  }, {
    title: 'Apply heading style 2',
    win: 'Control Alt 2',
    mac: 'Command Option 2'
  }, {
    title: 'Apply heading style 3',
    win: 'Control Alt 3',
    mac: 'Command Option 3'
  }, {
    title: 'Apply heading style 4',
    win: 'Control Alt 4',
    mac: 'Command Option 4'
  }, {
    title: 'Ordered list',
    win: 'Control Shift 7',
    mac: 'Command Shift 7'
  }, {
    title: 'Bullet list',
    win: 'Control Shift 8',
    mac: 'Command Shift 8'
  }, {
    title: 'Blockquote',
    win: 'Control Shift B',
    mac: 'Command Shift B'
  }, {
    title: 'Align text left',
    win: 'Ctrl Shift L',
    mac: 'Command Shift L'
  }, {
    title: 'Align text center',
    win: 'Ctrl Shift E',
    mac: 'Command Shift E'
  }, {
    title: 'Align text right',
    win: 'Ctrl Shift R',
    mac: 'Command Shift R'
  }]
}, {
  id: 'table',
  title: 'Table',
  commands: [{
    title: 'Create a table',
    win: 'Control Alt 5',
    mac: 'Control Option 5'
  }, {
    title: 'Accessibility properties',
    win: 'Control Alt 6',
    mac: 'Control Option 6'
  }, {
    title: 'Add row below',
    win: 'Control Alt Q',
    mac: 'Control Option Q'
  }, {
    title: 'Add column after',
    win: 'Control Alt W',
    mac: 'Control Option W'
  }, {
    title: 'Remove selected row',
    win: 'Control Alt E',
    mac: 'Control Option E'
  }, {
    title: 'Remove selected column',
    win: 'Control Alt R',
    mac: 'Control Option R'
  }, {
    title: 'Toggle header row',
    win: 'Control Alt T',
    mac: 'Control Option T'
  }, {
    title: 'Toggle header column',
    win: 'Control Alt Y',
    mac: 'Control Option Y'
  }]
}];
exports.shortcuts = shortcuts;
var KEYBOARD_SHORTCUTS_MODAL_ID = 'keyboard-shortcuts-modal';
exports.KEYBOARD_SHORTCUTS_MODAL_ID = KEYBOARD_SHORTCUTS_MODAL_ID;